import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class AspSettingsService {

  constructor( 
    private http: HttpClient,
  ) { }

  createTermsAndConditions(garageKey, termsAndConditions, termsAndConditionsType){
      let paramData = {      
        garageKey: garageKey,
        termsAndConditions: termsAndConditions,
        termsAndConditionsType: termsAndConditionsType,
        source: "web"
      };
      // console.log(paramData)
      console.log('-----Get User Details-----------');    
      return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/termsAndConditions/v1/create', paramData);
    }
  
    getTerms(garageKey:string) {
      return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}/termsAndConditions/v1/get/${garageKey}`);
    }
}
